import React, {useEffect, useState} from 'react';
import {apiAccess} from "../../../common/components/AxiosWrapper";
import Constants from "../../../common/components/constants";
import Spinner from "../Spinner/Spinner";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';


function Twitter(props) {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEnableOpen, setEnableModalParam] = useState(false);
    const [isDisableOpen, setDisableModalParam] = useState(false);
    const [isAlertOpen, setAlertModalParam] = useState(false);
    const [isCreateOpen, setCreateModalParam] = useState(false);
    const [contentId, setContentId] = useState(null)
    const [twitterNameInput, setTwitterNameInput] = useState("")

    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        loadFacebookList();
    }, [])

    /**
     * Facebookの読み込み　
     */
    const loadFacebookList = () => {
        setLoading(true)
        apiAccess.get(
            Constants.URLs.GET_TWITTER_ACCOUNT)
            .then((response) => {
                const successJson = response.data;
                setLoading(false)
                setList(successJson?.data ?? []);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const toggleItemChange = (bool) => {
        apiAccess.post(
            bool ? Constants.URLs.ENABLE_TWITTER_ACCOUNT : Constants.URLs.DISABLE_TWITTER_ACCOUNT, {
                "user_id": props.auth.userId,
                "linked_twitter_account_id": contentId
            })
            .then((response) => {
                const successJson = response.data;
                setLoading(false);
                toggleEnableModal(false)
                toggleDisableModal(false)
                successJson?.data && setList(successJson?.data);
            })
            .catch((error) => {
                console.log(error);
                setErrorMessage(error?.response?.data?.message ? error.response.data.message : "不明なエラーが発生しました");
                setAlertModalParam(true)
            });
    }

    const createItem = () => {
        apiAccess.post(
            Constants.URLs.ADD_TWITTER_ACCOUNT, {
                "twitter_user_name": twitterNameInput
            })
            .then((response) => {
                const successJson = response.data;
                setTwitterNameInput("");
                setLoading(false);
                toggleCreateModal(false);
                successJson?.data && setList(successJson?.data);
            })
            .catch((error) => {
                console.log(error);
                console.log(error.response)
                setErrorMessage(error?.response?.data?.message ? error.response.data.message : "不明なエラーが発生しました");
                setAlertModalParam(true)
            });
    }

    const toggleEnableModal = (bool) => {
        setEnableModalParam(bool)
    }
    const toggleDisableModal = (bool) => {
        setDisableModalParam(bool)
    }
    const toggleCreateModal = (bool) => {
        setCreateModalParam(bool)
    }
    const toggleAlertModal = (bool) => {
        setAlertModalParam(bool)
    }
    return (
        <div>
            <div className={"console_wrapper"}>
                <Button
                    variant="contained"
                    startIcon={<CreateIcon />}
                    color={"primary"}
                    disableElevation
                    onClick={() => { toggleCreateModal(true); }}
                >
                    新規登録
                </Button>
            </div>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: window.innerHeight }}>
                    {loading ?
                        <Spinner/> :
                        <Table aria-label="twitter list table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{background:"#f8f8f8"}}>名前</TableCell>
                                    <TableCell sx={{background:"#f8f8f8"}}>カテゴリ</TableCell>
                                    <TableCell className={"table_cell_datetime"} sx={{background:"#f8f8f8"}}>追加日</TableCell>
                                    <TableCell className={"table_cell_enable_check"} sx={{background:"#f8f8f8"}}/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.map((value, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">
                                            <a target={"_blank"}
                                            href={`https://twitter.com/@${value.linked_twitter_account_service_id}`}>@{value.linked_twitter_account_service_id}</a>
                                        </TableCell>
                                        <TableCell>{value.linked_twitter_account_description}</TableCell>
                                        <TableCell>{value.linked_twitter_account_linked_datetime}</TableCell>
                                        <TableCell align={"right"}>
                                            {value.linked_twitter_account_enabled ?
                                                <IconButton aria-label="delete" color="primary" onClick={() => {
                                                    setContentId(value.linked_twitter_account_id)
                                                    toggleDisableModal(true);
                                                }}>
                                                    <CheckBoxIcon/>
                                                </IconButton>
                                                :
                                                <IconButton aria-label="delete" color="primary" onClick={() => {
                                                    setContentId(value.linked_twitter_account_id)
                                                    toggleEnableModal(true);
                                                }}>
                                                    <CheckBoxOutlineBlankIcon/>
                                                </IconButton>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                </TableContainer>
            </Paper>


            <Dialog
                open={isCreateOpen}
                onClose={() => toggleCreateModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                maxWidth={"sm"}
                fullWidth={true}
            >
                <DialogTitle>{"新規追加"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>Twitterアカウントネームを入力してください</DialogContentText>
                    <TextField
                        autoFocus
                        id="outlined-Twitter-channel-id-input"
                        label="Twitterアカウントネーム"
                        type="text"
                        margin="normal"
                        fullWidth
                        autoComplete="current-password"
                        variant="outlined"
                        InputProps={{
                            startAdornment: <InputAdornment position="start">@</InputAdornment>,
                        }}
                        value={twitterNameInput}
                        onChange={(e) => {
                            setTwitterNameInput(e.target.value)
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button size={"large"} onClick={() => toggleCreateModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button size={"large"} variant="contained"
                            onClick={() => {
                                twitterNameInput && createItem();
                            }}
                            color="primary">
                        追加
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={isAlertOpen}
                onClose={() => toggleAlertModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle>{"エラー"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{errorMessage}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleAlertModal(false)} color="primary">
                        閉じる
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isDisableOpen}
                onClose={() => toggleDisableModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle>{"無効化の確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>選択したTwitterアカウントからの情報取得を無効にしますが、よろしいですか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleDisableModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button variant="contained" onClick={() => toggleItemChange(false)} color="primary">
                        無効にする
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={isEnableOpen}
                onClose={() => toggleEnableModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle>{"有効化の確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>選択したTwitterアカウントからの情報取得を有効にしますが、よろしいですか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleEnableModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button onClick={() => toggleItemChange(true)} color="primary" variant="contained">
                        有効にする
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Twitter;